import React, { useEffect, useState } from "react";

export default function Preloader() {
  const [hide, setHide] = useState(false);
  const [remove, setRemove] = useState(false);
  const letters = "INTELISOFT".split("");

  useEffect(() => {
    const t1 = setTimeout(() => setHide(true), 1600);
    const t2 = setTimeout(() => setRemove(true), 2300);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  if (remove) return null;

  return (
    <div className={`preloader ${hide ? "hide" : ""}`}>
      <div className="text-center">
        <div className="pre-spinner" />
        <div className="pre-letters">
          {letters.map((l, i) => (
            <span key={i} style={{ animationDelay: `${i * 0.1}s` }}>
              {l}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
